export { default } from "./Tabs.js";
export { default as tabsClasses } from "./tabsClasses.js";
export * from "./tabsClasses.js";